import { render, staticRenderFns } from "./WaterBill.vue?vue&type=template&id=0077142e&"
import script from "./WaterBill.vue?vue&type=script&lang=js&"
export * from "./WaterBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports